<i18n src="./resources/locales.json"></i18n>
<template>
  <v-dialog max-width="500px" :value="show">
    <v-card>
      <v-card-title>
        {{ $t('overwriteBP') }}
      </v-card-title>
      <v-card-text>
        {{ isSmtpEnabled ? $t('emailsToOverwrite') : $t('businessProcessToOverwrite') }}
        <ul>
          <li v-for="bp of businessProcessesNames" :key="bp.id">{{ bp.name }}</li>
        </ul>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onCancel">{{ $t('cancel') }}</v-btn>
        <v-btn text color="primary" @click="onConfirm">{{ $t('confirm') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'EcsConfirmSignatureOverwrite',
  props: {
    businessProcessesOverwrite: {
      type: Array,
      required: true
    },
    onConfirm: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    isSmtpEnabled: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters(['businessProcesses']),
    businessProcessesNames() {
      return this.businessProcessesOverwrite.reduce((accum, current) => {
        if (this.isSmtpEnabled) {
          accum = accum.concat({
            name: `${current.email} (${current.businessProcessName})`,
            id: `${current.businessProcessId}-${current.email}`
          });
          return accum;
        } else {
          accum = accum.concat({
            name: current.businessProcessName,
            id: current.businessProcessId
          });
          return accum;
        }
      }, []);
    }
  }
};
</script>

<style></style>
